module.exports = __webpack_public_path__ + "img/q3-opt-b.4fe33c78.png";